var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "dismiss",
          rawName: "v-dismiss",
          value: _vm.computedDismiss,
          expression: "computedDismiss",
        },
      ],
      staticClass: "jade-popover",
    },
    [
      _c(
        "div",
        {
          ref: "referenceRef",
          staticClass: "jade-popover__trigger",
          attrs: {
            role: "presentation",
            "aria-label": "trigger",
            "data-testid": "trigger",
            "aria-describedby": _vm.defineFloatingID,
          },
          on: { click: _vm.toggleOpen },
        },
        [_vm._t("trigger")],
        2
      ),
      _c("transition", { attrs: { name: "fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isVisible,
                expression: "isVisible",
              },
            ],
            ref: "floatingRef",
            staticClass: "absolute top-0 left-0 z-[99999]",
            style: { zIndex: _vm.zIndex },
            attrs: {
              tabindex: "-1",
              "data-testid": "floating",
              id: _vm.defineFloatingID,
            },
          },
          [_vm._t("default")],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }